module.exports = __webpack_public_path__ + "static/media/cert_80.4a0b9163.jpg";